import React, {useState} from "react";
import TablePelayanan from "../pelayanan/TablePelayanan";
import {showLoading, toast} from "../component/Alert";
import API from "../../apiService";
import DatePicker from "react-datepicker";
import moment from "moment";
import Table from "../component/Table";

const ApprovalLab = () => {

    const [datas, setDatas] = useState([])
    const [isLoading, setLoading] = useState(true)
    const [frDate, setFrDate] = useState(moment().toDate());
    const [enDate, setEnDate] = useState(moment().toDate());

    const fetchDatas = async () => {
        let param = {
            keyword: '',
            frDate: moment(frDate).format('YYYY-MM-DD'),
            enDate: moment(enDate).format('YYYY-MM-DD'),
        };
        showLoading("Mencari Data");
        const res = await API.post("/registration/lab/approval_list", param);
        if (res.code === 200) {
            toast({ status: "success", text: "Data Ditemukan" });
            setDatas(res.data)
            setLoading(false)
        } else {
            toast({ status: "error", text: "Data tidak ditemukan" });
            setDatas([])
            setLoading(false)
        }
    }

    const validate = async data => {
        showLoading("vaildate Data");
        const res = await API.post("/registration/lab/validate", {
            lab_id: data.id,
            frDate: moment(frDate).format('YYYY-MM-DD'),
            enDate: moment(enDate).format('YYYY-MM-DD'),
        });
        if (res.code === 200) {
            toast({ status: "success", text: "Berhasil" });
            setDatas(res.data)
            setLoading(false)
        } else {
            toast({ status: "error", text: "Gagal" });
            setDatas([])
            setLoading(false)
        }
    }

    return (
        <div className="container-fluid my-3">
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header border-0">
                            <div className="row">
                                <div className="col-md-2">
                                    <h3>Approval Lab</h3>
                                </div>
                            </div>
                        </div>
                        <div className={'card-body'}>
                            <div className="row">
                                <div className="col-md-2">
                                    <h3>Tanggal Kunjungan</h3>
                                </div>
                                <DatePicker
                                    className="form-control col-md-12"
                                    selected={frDate}
                                    onChange={(date) => {
                                        setFrDate(date)
                                    }}
                                    value={frDate}
                                    dateFormat="yyyy-MM-dd"
                                />
                                <DatePicker
                                    className="form-control col-md-12"
                                    selected={enDate}
                                    onChange={(date) => {
                                        setEnDate(date)
                                    }}
                                    value={enDate}
                                    dateFormat="yyyy-MM-dd"
                                />
                                <button
                                    style={{ marginLeft: "2%" }}
                                    className="btn btn-success"
                                    onClick={fetchDatas}
                                >
                                    CARI DATA
                                </button>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className="card">
                                        <Table
                                            headers={[
                                                "No",
                                                "NIK",
                                                "Nama",
                                                "Lab",
                                                "Approval",
                                                "Aksi",
                                            ]}
                                            data={datas}
                                            columnMapper={(data, key) => [
                                                data.visit.patients.nik,
                                                data.visit.patients.name + ' ' + data.visit.patients.last_name,
                                                data.details?.filter(v => !v.log)?.length ? data.details.filter(v => !v.log).map(v => `${v.lab.name}: ${v.result ?? ''}`).reduce((p, c) => [ p, <br />, c ]) : '',
                                                data.send_wa ? (<label className={'text-success'}><b>Approved</b></label>) : '',
                                                data.validated ? <label className={'text-success'}><b>Validated</b></label> : (<button className={'btn btn-success'} onClick={() => validate(data)}>Validate</button>),
                                            ]}
                                            pagination={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ApprovalLab